import * as React from 'react';
import TextField from '@mui/material/TextField'; // Import TextField
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import StatusContext from '../../../contexts/StatusContext';
import { PushButton } from '../pushbutton/PushButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const LoginConfirmDialog = ({ title, text, verifySecurityCode }) => {
  const {
    showloginconfirmdialog,
    setShowLoginConfirmDialog,
    
    changeLanguage,

    securitycodestatus, 
    setSecurityCodeStatus,

  } = React.useContext(StatusContext);

 
  // State variable for security code
  const [securityCode, setSecurityCode] = React.useState('');
 

  
  const handleClose = () => {
  
  }
  const handleOK = async () => {
   
    if (securityCode.length === 0)
    {
      setSecurityCodeStatus(changeLanguage("signup", "entersecuritycode"))
      return
    }

    verifySecurityCode(securityCode)

  };


  const handleCloseDialog = () => {
  
    setSecurityCode('')
    setSecurityCodeStatus('')
 
    setShowLoginConfirmDialog(false)

  }

  const handleSecurityCodeChange = (event) => {
 
    setSecurityCode(event.target.value);
    setSecurityCodeStatus('')
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showloginconfirmdialog}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>

        <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
          <CloseIcon />
        </IconButton>

        <hr />
        <DialogContent>
          <Typography gutterBottom>
            <span style={{ color: 'maroon' }}>{text}</span>
          </Typography>

          {/* Add TextField for Security Code */}
          <TextField
            autoFocus
            margin="dense"
            id="security-code"
            label="Security code"
            type="text"
            variant="outlined"
            value={securityCode} // Bind value to the state variable
            onChange={handleSecurityCodeChange} // Handle change
          />


          <Typography gutterBottom>
              <span style={{ color: 'maroon' }}>{securitycodestatus}</span>
          </Typography>
      
        </DialogContent>
        <DialogActions>
          <PushButton onClick={handleOK} label="OK" />
        </DialogActions>
   
      </BootstrapDialog>
       

    </React.Fragment>
  );

    
};